import { render, staticRenderFns } from "./home_merchant.vue?vue&type=template&id=64f040af&scoped=true"
import script from "./home_merchant.vue?vue&type=script&lang=js"
export * from "./home_merchant.vue?vue&type=script&lang=js"
import style0 from "./home_merchant.vue?vue&type=style&index=0&id=64f040af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f040af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/adam/Documents/Private_Repository/sjtx/backendAdmin/sjtx_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f040af')) {
      api.createRecord('64f040af', component.options)
    } else {
      api.reload('64f040af', component.options)
    }
    module.hot.accept("./home_merchant.vue?vue&type=template&id=64f040af&scoped=true", function () {
      api.rerender('64f040af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_merchant.vue"
export default component.exports